export default __webpack_public_path__ + "static/media/bg-global-right.cb5c7d28.svg";